'use client';

import { SignalStatus } from '@terra/shared-schemas-orchestrator';
import { useCallback } from 'react';
import { useMainContentTabs } from '../../../store/layoutStore';
import { tabScopedStore } from '../../../store/tab/tabScopedStore';
import { getActiveTabScopeKey } from '../../../store/tab/active-tab-scope-key';
import { sidebarTabMapping } from '../../layout/utils';

export function useNavigateToBlockedSignals({
  applicationId,
}: {
  applicationId: string;
}) {
  const { navigateInActiveTab } = useMainContentTabs();

  return useCallback(() => {
    navigateInActiveTab(sidebarTabMapping.signals);

    const scopeKey = getActiveTabScopeKey(applicationId);

    if (scopeKey) {
      tabScopedStore
        .getState()
        .updateEntry(scopeKey, { statusFilter: [SignalStatus.BLOCKED] });
    }
  }, [applicationId, navigateInActiveTab]);
}
